import { defineComponent as h, computed as v, watch as k, useTemplateRef as x, createElementBlock as c, openBlock as i, normalizeClass as E, createCommentVNode as p, Fragment as S, createVNode as y, createBlock as C } from "vue";
import { REGEX as g } from "@scalar/oas-utils/helpers";
import { emitCustomEvent as u } from "@scalar/workspace-store/events";
import w from "../../components/Form/Form.vue.js";
import O from "../../components/Server/ServerVariablesForm.vue.js";
import { useActiveEntities as B } from "../../store/active-entities.js";
import { useWorkspace as R } from "../../store/store.js";
const $ = /* @__PURE__ */ h({
  __name: "CollectionServerForm",
  props: {
    collectionId: { default: "" },
    serverUid: { default: "" }
  },
  setup(n) {
    const l = n, { activeWorkspaceCollections: d } = B(), { servers: f, serverMutators: s } = R(), m = [
      {
        label: "URL",
        key: "url",
        placeholder: "https://void.scalar.com",
        type: "text"
      },
      {
        label: "Description",
        key: "description",
        placeholder: "Production",
        type: "text"
      }
    ], t = v(() => {
      const e = d.value.find(
        (r) => r.uid === l.collectionId
      );
      return f[e && typeof l.serverUid == "string" && l.serverUid === "default" ? e.servers[0] ?? "" : (e == null ? void 0 : e.servers.find((r) => r === l.serverUid)) ?? ""];
    }), b = v(() => {
      var e, r;
      return (e = t.value) != null && e.url ? ((r = t.value.url.match(g.PATH)) == null ? void 0 : r.map((a) => a.slice(1, -1))) ?? [] : [];
    });
    k(
      b,
      (e) => {
        if (!t.value)
          return;
        const r = t.value.variables ? { ...t.value.variables } : {};
        Object.keys(r).forEach((a) => {
          e.includes(a) || delete r[a];
        }), e.forEach((a) => {
          r[a] || (r[a] = { default: "" });
        }), s.edit(t.value.uid, "variables", r), u(o.value, "store-update-selected-server-properties", {
          key: "variables",
          value: r,
          options: {
            disableOldStoreUpdate: !0
          }
        });
      },
      { immediate: !0 }
    );
    const U = (e, r) => {
      !d.value || !t.value || (s.edit(t.value.uid, e, r), (e === "url" || e === "description") && u(o.value, "store-update-selected-server-properties", {
        key: e,
        value: r,
        options: {
          disableOldStoreUpdate: !0
        }
      }));
    }, _ = (e, r) => {
      if (!t.value)
        return;
      const a = t.value.variables || {};
      a[e] = { ...a[e], default: r }, s.edit(t.value.uid, "variables", a), u(o.value, "store-update-selected-server-properties", {
        key: "variables",
        value: a,
        options: {
          disableOldStoreUpdate: !0
        }
      });
    }, o = x("wrapper-ref");
    return (e, r) => {
      var a;
      return i(), c("div", {
        ref: "wrapper-ref",
        class: E(["divide-0.5 flex w-full flex-col divide-y rounded-b-lg text-sm", ((a = t.value) == null ? void 0 : a.variables) && "bg-b-1"])
      }, [
        t.value ? (i(), c(S, { key: 0 }, [
          y(w, {
            data: t.value,
            onUpdate: U,
            options: m
          }, null, 8, ["data"]),
          t.value.variables ? (i(), C(O, {
            key: 0,
            variables: t.value.variables,
            "onUpdate:variable": _
          }, null, 8, ["variables"])) : p("", !0)
        ], 64)) : p("", !0)
      ], 2);
    };
  }
});
export {
  $ as default
};
